import React, { forwardRef } from "react";
import { getDate, currentDate } from "utils/formatDate";
import { formatNumber2 } from "utils/currencyFormat";

const InDsChiTietLoiNhuan = forwardRef(({ listData, totals, title, reportTypeInt }, ref) => {

    const getColumns = () => {
        const baseCols = [
            { header: 'STT', width: '5%' },
            { header: 'Ngày', accessor: 'NgayGiaoDich', width: '10%', align: 'center', render: (item) => getDate(item.NgayGiaoDich) },
            { header: 'Nhân viên', accessor: 'NhanVien', width: '10%', align: 'left' },
        ];

        const customerCol = { 
            header: reportTypeInt === 7 ? 'Chủ nợ' : 'Khách hàng', 
            accessor: 'KhachHang', width: '15%', align: 'left' 
        };
        const contractCol = { header: 'Hợp đồng', accessor: 'MaHopDong', width: '15%', align: 'center' };
        const colTienLai = { header: 'Tiền thu lãi', accessor: 'Cot_TienThuLai', width: '10%', align: 'right', sum: totals.Sum_TienThuLai };
        const colPhiKy = { header: 'Phí hàng kỳ', accessor: 'Cot_PhiHangKy', width: '10%', align: 'right', sum: totals.Sum_PhiHangKy };
        const colThuKhac = { header: 'Tiền thu khác', accessor: 'Cot_TienThuKhac', width: '10%', align: 'right', sum: totals.Sum_TienThuKhac };
        const colPhiKho = { header: 'Phí kho', accessor: 'Cot_PhiKho', width: '10%', align: 'right', sum: totals.Sum_PhiKho }; 
        const colTongThu = { header: 'Tổng thu', accessor: 'Cot_TongTien', width: '10%', align: 'right', sum: totals.Sum_TongLoiNhuan };
        const colTongChi = { header: 'Tổng chi', accessor: 'Cot_TongTien', width: '10%', align: 'right', sum: totals.Sum_TongLoiNhuan };

        if ([1, 2,3,4].includes(reportTypeInt)) {
            return [...baseCols, customerCol, contractCol, colTienLai, colPhiKy, colThuKhac, colPhiKho, colTongThu];
        }

        if (reportTypeInt === 7) {
            const colChiLai = { header: 'Tiền chi lãi', accessor: 'Cot_TienThuLai', width: '10%', align: 'right', sum: totals.Sum_TienThuLai };
            const colChiKhac = { header: 'Chi khác', accessor: 'Cot_TienThuKhac', width: '10%', align: 'right', sum: totals.Sum_TienThuKhac };
            return [...baseCols, customerCol, contractCol, colChiLai, colChiKhac, colPhiKho, colTongChi];
        }

        if ([5, 6, 8, 9].includes(reportTypeInt)) {
            const colLoaiPhieu = { header: 'Loại phiếu', accessor: 'DienGiai', width: '20%', align: 'center' };
            const colSoTien = { header: 'Số tiền', accessor: 'Cot_TongTien', width: '15%', align: 'right', sum: totals.Sum_TongLoiNhuan };
            return [...baseCols, customerCol, colLoaiPhieu, colSoTien];
        }
        return [];
    };

    const columns = getColumns();

    return (
        <div ref={ref} id="tblPrintChiTietLoiNhuan" style={{ padding: "30px", width: "100%" }}>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "20px", fontWeight: "bold" }}>
                    DANH SÁCH TỔNG TIỀN {title}
                </h2>
                <p style={{ margin: "5px 0 0 0", fontSize: "12px", fontStyle: "italic" }}>
                    Ngày in: {currentDate()}
                </p>
            </div>
            <table
                border="1"
                className="table-bordered"
                style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    fontFamily: "Arial",
                    fontSize: "11px",
                    color: "#000",
                }}
            >
                <thead>
                    <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
                        {columns.map((col, idx) => (
                            <th key={idx} style={{ textAlign: "center", padding: "5px", verticalAlign: 'middle', width: col.width }}>
                                {col.header}
                                {col.sum !== undefined && (
                                    <>
                                        <br />
                                        <span style={{ color: 'red', fontWeight: 'bold' }}>
                                            $= {formatNumber2(col.sum)}
                                        </span>
                                    </>
                                )}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {listData?.map((item, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((col, colIndex) => {
                                if (col.header === 'STT') {
                                    return <td key={colIndex} style={{ textAlign: "center", padding: "5px" }}>{rowIndex + 1}</td>;
                                }

                                const align = col.align || 'left';
                                const value = col.render ? col.render(item) : item[col.accessor];

                                return (
                                    <td key={colIndex} style={{ textAlign: align, padding: "5px" }}>
                                        {value}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                    {(!listData || listData.length === 0) && (
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center", padding: "10px" }}>
                                Không có dữ liệu
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <style>
                {`
                    @media print {
                        @page { size: A4 portrait; margin: 10mm; }
                        #tblPrintChiTietLoiNhuan .table-bordered th, 
                        #tblPrintChiTietLoiNhuan .table-bordered td { 
                            border: 1px solid #000 !important; 
                            padding: 4px;
                        }
                    }
                `}
            </style>
        </div>
    );
});

export default InDsChiTietLoiNhuan;